module.exports = __webpack_public_path__ + "img/gs.99e61752.png";